var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,30v2A12.013,12.013,0,0,0,58,20H56A10.011,10.011,0,0,1,46,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,2H27a1,1,0,0,0-1,1V20A16.007,16.007,0,0,0,41,35.949v19.5l-1.088.681a4.986,4.986,0,0,0-4.366-4.071A4.942,4.942,0,0,0,36,50a4.985,4.985,0,0,0-9-2.969,4.968,4.968,0,0,0-8.929,2.263c-2.072-2.932-6.36-5.42-15.254-3.77a1,1,0,0,0-.787,1.229c.075.3,1.924,7.05,12.047,9.486A4.906,4.906,0,0,0,14,57a4.985,4.985,0,0,0,9,2.969,4.954,4.954,0,0,0,8,0,5,5,0,0,0,2.27,1.7A.99.99,0,0,0,34,62H54a1,1,0,0,0,.53-1.848L47,55.445v-19.5A16.007,16.007,0,0,0,62,20V3A1,1,0,0,0,61,2ZM28,4H60v7.332l-.021.006c-.042.01-.08.023-.121.034-.206.053-.4.111-.589.171l-.206.07q-.24.084-.467.172l-.164.063q-.287.115-.562.231A9.687,9.687,0,0,1,53.5,13a9.63,9.63,0,0,1-4.364-.922A11.614,11.614,0,0,0,44,11a11.6,11.6,0,0,0-5.136,1.078A9.614,9.614,0,0,1,34.5,13a9.689,9.689,0,0,1-4.371-.921q-.274-.116-.559-.23l-.168-.065c-.15-.059-.3-.115-.465-.171-.067-.023-.135-.047-.2-.069q-.282-.093-.594-.174c-.04-.01-.075-.022-.115-.032L28,11.332Zm3,43a3,3,0,1,1-3,3A3,3,0,0,1,31,47Zm-8,0a3,3,0,1,1-3,3A3,3,0,0,1,23,47Zm-18.62.29c8.517-1.268,11.82,1.751,13.022,5a4.838,4.838,0,0,0-.8.352l-3.956-3.4a1,1,0,1,0-1.3,1.518l3.717,3.192c-.1.133-.2.265-.294.408C7.889,52.774,5.269,49.1,4.38,47.29ZM19,60a3,3,0,1,1,3-3A3,3,0,0,1,19,60Zm8,0a3,3,0,1,1,3-3A3,3,0,0,1,27,60Zm5-3a3,3,0,1,1,3,3A3,3,0,0,1,32,57Zm18.513,3H38.974a4.961,4.961,0,0,0,.737-1.391l2.819-1.761A1,1,0,0,0,43,56V36h2V56a1,1,0,0,0,.47.848ZM46,34H42A14.015,14.015,0,0,1,28,20V13.414l.1.029q.236.077.457.161c.065.024.132.047.2.072.2.08.4.163.605.248A11.666,11.666,0,0,0,34.5,15a11.6,11.6,0,0,0,5.136-1.078A9.614,9.614,0,0,1,44,13a9.629,9.629,0,0,1,4.363.922A11.616,11.616,0,0,0,53.5,15a11.662,11.662,0,0,0,5.146-1.076c.2-.085.4-.169.608-.249.06-.024.122-.044.182-.067.153-.058.309-.114.471-.166L60,13.414V20A14.015,14.015,0,0,1,46,34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 6,
    width: 2,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviding);
export default __webpack_public_path__ + "static/media/providing.897f0ae188c4c21ac4578f1459c0e94a.svg";
export { ForwardRef as ReactComponent };